// Angular
import { ElementRef, Injectable } from '@angular/core';
import { animate, AnimationBuilder, style } from '@angular/animations';

@Injectable()
export class SplashScreenService {
	// Private properties
	private el: ElementRef;
	private stopped: boolean;
	private visible = false;

	/**
	 * Service constctuctor
	 *
	 * @param animationBuilder: AnimationBuilder
	 */
	constructor(private animationBuilder: AnimationBuilder) {
	}

	/**
	 * Init
	 *
	 * @param element: ElementRef
	 */
	init(element: ElementRef) {
		this.el = element;
	}

	/**
	 * Hide
	 */
	hide() {
		this.visible = false;
		if (!this.el) {
			return;
		}

		const player = this.animationBuilder.build([
			style({opacity: '1'}),
			animate(800, style({opacity: '0'}))
		]).create(this.el.nativeElement);

		player.onDone(() => {
			player.destroy();
			if (!this.visible) {
				this.setHiddenStyles();
			}
			this.stopped = true;
		});

		player.play();
	}

	show() {
		this.visible = true;
		if (this.el) {
			const player = this.animationBuilder.build([
				style({opacity: '0', zIndex: '1100'}),
				animate(800, style({opacity: '0.5'}))
			]).create(this.el.nativeElement);

			player.onDone(() => {
				if (this.visible && this.el.nativeElement && this.el.nativeElement.style) {
					this.el.nativeElement.style.display = 'flex';
					this.el.nativeElement.style.pointerEvents = '';
				} else if (!this.visible) {
					this.setHiddenStyles();
				}
				this.stopped = false;
			});

			player.play();
		}
	}

	private setHiddenStyles() {
		if (this.el && this.el.nativeElement && this.el.nativeElement.style) {
			this.el.nativeElement.style.display = 'none';
			this.el.nativeElement.style.pointerEvents = 'none';
		}
	}
}
